<template>
    <maintain-announcement v-if="displayAnnouncement"
                           :dairyid="dairyid"
                           :dairyname="dairyname"
                           :announcement="selectedAnnouncement"
                           @close="listAnnouncements()">
    </maintain-announcement>

    <modal-template>
        <template #header>
            <div style="width:100%;float:left;background:black;color:white;">
                <div style="float:left;padding-left:1%;padding-top:1%;font-weight:bold;font-size:larger;font-style:italic;">
                    <span>maintain announcements</span>
                </div>
                <div style="float:right;text-align:right;">
                    <label class="close-icon-style" v-on:click="$emit('close', true)">
                        <font-awesome-icon icon="xmark" size="xl"/>
                        <span style="display: block;">close</span>
                    </label>
                </div>
            </div>
            <div style="width:100%;float:left;padding-top:1%;color:black;">
                <div style="float:left;">
                    <div style="text-align:left;font-size:larger;font-weight:bold;">
                        <sup>[{{ dairyid }}]</sup> {{ dairyname }}
                    </div>
                </div>
                <div style="float:right;padding-right:5%;">
                    <div style="float:left;">
                        <label class="action-icon-style" v-on:click="maintainAnnouncement(newAnnouncement)">
                            <font-awesome-icon icon="newspaper" size="xl"/>
                            <span style="display: block;">new</span>
                        </label>
                    </div>
                    <div style="float:right;">
                        <label class="action-icon-style" v-on:click="listAnnouncements()">
                            <font-awesome-icon icon="arrows-rotate" size="xl"/>
                            <span style="display: block;">refresh</span>
                        </label>
                    </div>
                </div>
            </div>
        </template>
        <template #body>
            <div class="table-container" style="max-height:345px;">
                <table>
                    <thead>
                    <tr>
                        <th>start</th>
                        <th>end</th>
                        <th>announcement</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="announcement in announcements" :key="announcement.dairyId"
                        v-on:click="maintainAnnouncement(announcement)">
                        <td>{{ announcement.startDate }}</td>
                        <td>{{ announcement.endDate }}</td>
                        <td>{{ announcement.message.substring(0, 74) + "..." }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </modal-template>
</template>

<script>
import ModalTemplate from '@/components/ModalTemplate'
import MaintainAnnouncement from '@/components/administrator/dairy/announcement/MaintainAnnouncement.vue'

export default {
    name: 'BannerAnnouncement',
    props: ['dairyid', 'dairyname'],
    emits: ['close', 'apierror', 'apierrortext'],
    components: {
        ModalTemplate,
        MaintainAnnouncement
    },
    data: function () {
        return {
            announcements: [],
            selectedAnnouncement: {},
            displayAnnouncement: false,
            newAnnouncement: {
                dairyId: this.dairyid,
                startDate: new Date().toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                }),
                endDate: new Date().toLocaleDateString('en-US', {
                    month: '2-digit',
                    day: '2-digit',
                    year: 'numeric',
                }),
                message: '',
                status: '',
                createdBy: '',
                createdOn: '',
                changedBy: '',
                changedOn: '',
            },
        }
    },
    methods: {
        listAnnouncements() {
            this.displayAnnouncement = false

            this.axios
                .get('admin/announcement/list', {
                    params: {
                        dairyId: this.dairyid
                    }
                })
                .then(response => {
                    this.announcements = response.data
                })
                .catch(error => {
                    this.setApiError(true)
                    this.setApiErrorText(error.response.statusText)
                })
        },
        maintainAnnouncement(announcement) {
            this.selectedAnnouncement = announcement
            this.displayAnnouncement = true
        },
        setApiError: function (isError) {
            this.$emit('apierror', isError)
        },
        setApiErrorText: function (text) {
            this.$emit('apierrortext', text)
        }
    },
    mounted() {
        this.listAnnouncements()
    },
}
</script>

<style scoped>
.close-icon-style {
    color: white;
    text-align: center;
    cursor: pointer;
    width: 80px;
}

.close-icon-style:hover {
    font-weight: bolder;
}

.action-icon-style {
    color: black;
    text-align: center;
    cursor: pointer;
    width: 80px;
}

.action-icon-style:hover {
    font-weight: bolder;
}
</style>
